module.exports = __webpack_public_path__ + "static/media/arrow.ce7c46ea.svg";